import { jsx, jsxs } from "react/jsx-runtime";
import React, { useMemo, useRef } from "react";
import { Dialog, useHotkeys } from "@blueprintjs/core";
import { noop, isFunction } from "lodash-es";
import { ResizableDraggableDialog } from ".";
export default (topLevelDialogProps = {}) => (Component) => (props) => {
  const r = useRef();
  const memoedHotkeys = useMemo(
    () => [
      {
        combo: topLevelDialogProps.useCmdEnter ? "cmd+enter" : "enter",
        global: true,
        allowInInput: true,
        onKeyDown: () => {
          function doNotTriggerClick() {
          }
          try {
            let triggerClick = function() {
              parentEl?.querySelector(`button[type='submit']`).click();
            };
            if (!document.activeElement) return doNotTriggerClick();
            if (!document.activeElement.closest(".tg-allow-dialog-form-enter")) {
              if (document.activeElement.closest(".bp3-multi-select"))
                return doNotTriggerClick();
              if (document.activeElement.closest(".tg-stop-dialog-form-enter"))
                return doNotTriggerClick();
              if (document.activeElement.type === "textarea")
                return doNotTriggerClick();
            }
            const parentEl = r.current?.closest(".bp3-dialog-container");
            const dialogs = document.querySelectorAll(
              ".bp3-dialog-container"
            );
            const numDialogs = dialogs?.length;
            if (numDialogs > 1) {
              const topMostDialog = dialogs[numDialogs - 1];
              if (topMostDialog === parentEl) {
                triggerClick();
              }
            } else {
              triggerClick();
            }
          } catch (error) {
            console.error(`error:`, error);
          }
        }
      }
    ],
    []
  );
  useHotkeys(memoedHotkeys);
  let otherTopLevelProps, getDialogProps = noop;
  if (isFunction(topLevelDialogProps)) {
    getDialogProps = topLevelDialogProps;
  } else {
    const {
      footerProps,
      getDialogProps: _pullOff,
      ...additionalProps
    } = topLevelDialogProps;
    otherTopLevelProps = additionalProps;
    getDialogProps = topLevelDialogProps.getDialogProps || noop;
  }
  const { dialogProps, hideModal, ...otherProps } = props;
  const extraDialogProps = {
    ...otherTopLevelProps,
    ...dialogProps,
    ...getDialogProps(props)
  };
  const DialogToUse = extraDialogProps.isDraggable ? ResizableDraggableDialog : Dialog;
  return /* @__PURE__ */ jsxs(
    DialogToUse,
    {
      canOutsideClickClose: false,
      isOpen: true,
      onClose: (e) => {
        e.stopPropagation();
        if (e.key === "Escape" && extraDialogProps.canEscapeKeyClose === false) {
          return;
        }
        hideModal(e);
      },
      ...extraDialogProps,
      canEscapeKeyClose: true,
      style: { ...extraDialogProps.style },
      children: [
        /* @__PURE__ */ jsx("div", { ref: r }),
        /* @__PURE__ */ jsx(Component, { hideModal, ...otherProps })
      ]
    }
  );
};
